import Vue from 'vue'
import config from '@/config/index'

export default {
  namespaced: true,
  state: {
    academicYear: null,
    academicYearItems: []
  },
  getters: {
    academicYear (state) {
      return state.academicYear
    },
    academicYearItems (state) {
      return state.academicYearItems
    }
  },
  mutations: {
    setAcademicYear (state, payload) {
      state.academicYear = payload
    },
    setAcademicYearItems (state, payload) {
      state.academicYearItems = payload
    }
  },
  actions: {
  	loadItems ({ commit, dispatch }, payload) {
      console.log('-> loadItems')
      return Vue.axios.get(`${config.serverURI}/parkingRequests`)
    },
    loadItemsAsPage ({ commit, dispatch }, pagination) {
      console.log('-> loadItemsAsPage', pagination)
      return Vue.axios.get(`${config.serverURI}/parkingRequests/page`, { params: pagination })
    },
    create ({ commit, dispatch }, payload) {
      console.log('-> create', payload)
      return Vue.axios.post(`${config.serverURI}/parkingRequests/create`, payload)
    },
    update ({ commit, dispatch }, payload) {
      console.log('-> update', payload)
      return Vue.axios.put(`${config.serverURI}/parkingRequests/${payload.id}`, payload)
    },
    delete ({ commit, dispatch }, payload) {
      console.log('delete', payload)
      return Vue.axios.delete(`${config.serverURI}/parkingRequests/${payload.id}`)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/parkingRequest.js